export enum PaymentStatus {
  NotSet = '0',
  Pending = '1',
  Paid = '2',
  Canceled = '3',
  Reserved = '4',
  CanceledPartially = '5',
}
